import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button } from '@mui/material';

import { useLazyGetEncounterTextInputQuery } from '../store/hooks';

/**
 * On-demand reveal for a text input's stored content on the admin encounter
 * page. The content is only fetched when the admin clicks Reveal — the
 * encounter detail payload never carries input text by default.
 */
export function TextInputReveal({
  encounterId,
  encounterDocumentId,
}: {
  encounterId: string;
  encounterDocumentId: string;
}) {
  const [revealed, setRevealed] = useState(false);
  const [fetchTextInput, { data, isFetching, isError }] = useLazyGetEncounterTextInputQuery();

  const handleToggle = () => {
    if (!revealed) {
      fetchTextInput({ encounterId, encounterDocumentId }, true);
    }
    setRevealed(!revealed);
  };

  return (
    <div className="mt-2">
      <Button
        size="small"
        variant="text"
        startIcon={revealed ? <VisibilityOff /> : <Visibility />}
        onClick={handleToggle}
      >
        {revealed ? 'Hide text' : 'Reveal text'}
      </Button>
      {revealed &&
        (isFetching ? (
          <p className="mt-1 text-xs text-gray-500">Loading text…</p>
        ) : isError ? (
          <p className="mt-1 text-xs text-red-600">Could not load this text input.</p>
        ) : data ? (
          data.content ? (
            <pre className="mt-1 max-h-64 overflow-y-auto whitespace-pre-wrap rounded bg-gray-50 p-2 font-sans text-sm text-gray-800">
              {data.content}
            </pre>
          ) : (
            <p className="mt-1 text-xs italic text-gray-500">This text input is empty.</p>
          )
        ) : null)}
    </div>
  );
}
